import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { memo, useCallback } from 'react';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';
import Input from '../../../../Input';
import { updateFlightSearchObj } from '../../../../../store/slices/flight';

const CabinInput = ({ tripId, currentIndex, variant }) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const { searchInputs } = useSelector(flightSearchInput(tripId, isTripSearch));
  const cabinValue = searchInputs.flightSegments?.[currentIndex]?.cabin || '';

  const handleCabinChange = useCallback(
    (value) => {
      const payload = {
        tripId,
        searchObj: {
          flightSegments: searchInputs.flightSegments ? [...searchInputs.flightSegments] : [],
          page: 1,
        },
      };

      payload.searchObj.flightSegments[currentIndex] = {
        ...payload.searchObj.flightSegments[currentIndex],
        cabin: value,
      };

      if (isTripSearch) dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
      else dispatch(updateFlightSearchObj(payload));
      track('handleBookingClassChange.handleChange', {
        bookgClass: value,
        currentIndex,
        tripId,
      });
    },
    [currentIndex, dispatch, isTripSearch, searchInputs.flightSegments, track, tripId],
  );

  return (
    <Input
      className={`border-gray-500 border-opacity-20 border-2 sm:px-4 sm:py-3 px-4 py-2 text-base font-medium w-full focus:outline-none h-full capitalize 
      ${isTripSearch ? 'placeholder-black rounded-r-2xl bg-searchInput-0' : 'placeholder-gray-700  rounded-2xl'} ${variant}`}
      type="text"
      maxLength={1}
      placeholder="Booking Class"
      title="Booking Class"
      onChange={(e) => handleCabinChange(e.target.value)}
      value={cabinValue}
    />
  );
};

CabinInput.propTypes = {
  tripId: PropTypes.string,
  currentIndex: PropTypes.number,
  variant: PropTypes.string,
};

CabinInput.defaultProps = {
  tripId: undefined,
  currentIndex: undefined,
  variant: undefined,
};
export default memo(CabinInput);
